<i18n>
{
  "en": {
    "header": "Payment and Confirmation",
    "suvUpgrade": {
      "checkbox": {
        "label": "Allow SUV upgrade at no additional charge if a sedan is unavailable"
      }
    },
    "tos": {
      "checkbox": {
        "label": "I have read and agree to the above terms and conditions"
      }
    }
  }
}
</i18n>
<template>
  <div class="ui segment">
      <h4 class="ui header">Quote</h4>

      <CostTable v-bind:fareLineItems="lineItems()" v-bind:showFeeInfo="false"></CostTable>

      <Payment @paymentFunctionUpdated="onPaymentFunctionUpdated"></Payment>

      <div class="ui form">
        <div class="inline field" v-if="reservation.selectedQuote.vehCode === 'sedan'">
          <div class="ui checkbox">
            <input type="checkbox" checked="" tabindex="0" class="hidden" v-model = "upgrades" v-on:change="onUpdate()">
            <label>Allow SUV upgrade at no additional charge if a sedan is unavailable</label>
          </div>
        </div>

        <p>Please note that this is a reservation request and does not guarantee service until it has been reviewed and accepted by Aces Town Car Service. You will receive an email when your reservation has been accepted. Reservations must be canceled at least 4 hours in advance to avoid being held responsible for payment. By making this reservation, you acknowledge you have read and agree to our <a v-on:click="showTermsOfService()"> complete terms and conditions</a>.</p>

        <div class="inline field">
          <div class="ui checkbox">
            <input type="checkbox" tabindex="0" class="hidden" v-model = "tosAgreed" v-on:change="onUpdate()">
            <label>I have read and agree to the above terms and conditions</label>
          </div>
        </div>

        <div class="field">
          <label>Additional Notes</label>
          <input v-model="clientNotes" type="text" name="email" placeholder="Driver instructions, Apt/Ste#, etc."  v-on:change="onUpdate()">
        </div>
      </div>

      <div class="ui longer modal">
        <div class="header">Service Terms and Conditions</div>
        <div class="scrolling content" v-html="termsOfService()">
        </div>
        <div class="actions">
          <div class="ui approve button">Agree</div>
        </div>
      </div>
  </div>

</template>

<script>
  import { textUtil } from './mixins/textUtil.js'
  import RideType from '../models/ride_type.js'
  import { TermsOfService } from '../models/terms_of_service.js'
  import CostTable from './CostTable.vue'
  import Payment from './Payment.vue'

  export default {
    name: 'Request',
    mixins: [ textUtil ],
    components: { CostTable, Payment },
    props: {
      reservation: Object,
      additionalLineItems: Object,
      rideType: Object
    },
    data: function () {
      return {
        tosAgreed: false,
        upgrades: true,
        paymentFunction: null,
        clientNotes: ''
      }
    },
    methods: {
      onPaymentFunctionUpdated: function (value) {
        this.paymentFunction = value.paymentFunction
        this.onUpdate()
      },
      onUpdate: function () {
        this.$emit('requestUpdated', { tosAgreed: this.tosAgreed, upgrades: this.upgrades, paymentFunction: this.paymentFunction, clientNotes: this.clientNotes })
      },
      lineItems: function () {
        var lineItems = []
        if (this.rideType !== RideType.Types.POINT_TO_POINT) {
          lineItems = this.reservation.selectedQuote.fares.filter(fare => fare.fareProfile === 'airport')[0].fareLineItems
        } else {
          lineItems = this.reservation.selectedQuote.fares.filter(fare => fare.fareProfile === 'pointtopoint')[0].fareLineItems
        }
        return lineItems.concat(this.additionalLineItems).filter(item => item.lineItemType !== 'total')
      },
      total: function () {
        var itemsToSum = this.lineItems()
        return itemsToSum.reduce((acc, item) => { return acc + item.lineItemCost }, 0)
      },
      termsOfService: function () {
        return TermsOfService.verbose
      },
      showTermsOfService: function () {
        var v = this
        $('.ui.longer.modal')
          .modal({
            closable: false,
            onDeny: function () {
              v.tosAgreed = false
            },
            onApprove: function () {
              v.tosAgreed = true
            }
          })
          .modal('show')
      }
    },
    mounted () {
      $('.ui.checkbox').checkbox()
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Request.vue